import { rundownLabel } from '@brush/ui';
import { usePeriodChoice } from '../periods/context';

/**
 * The Rundown period in force, as text, with a Change link to Settings → Preferences → Periods
 * (docs/specs/user-preferences.md UP21, A6). Drawn in the Rundown's control slot at every width — under the rail's
 * heading, as the tablet strip's first cell, and at the start of the phone's one line (known gap 148) — so whatever
 * bounds the rundown is said beside it. It is not a control: the choice is made in the Periods card. Chalk on the
 * charcoal rail, never signal orange: a period is not work waiting on anybody.
 */
export function RundownPeriodSummary({ onChange }: { onChange: () => void }) {
  const [period] = usePeriodChoice('rundown.period');

  return (
    <span className="inline-flex shrink-0 items-baseline gap-2 whitespace-nowrap text-[11px] font-semibold uppercase tracking-[0.06em] text-rail-100">
      <span>{rundownLabel(period)}</span>
      <button
        type="button"
        onClick={onChange}
        className="text-[10.5px] font-normal normal-case tracking-normal text-rail-300 underline underline-offset-2 hover:text-white"
      >
        Change
      </button>
    </span>
  );
}
